import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

export type StatusBarData = {
  color: string
  percentage: string
}

interface StatusBarProps {
  data: StatusBarData[]
  height?: number
}

const StatusBar = ({ data, height = 8 }: StatusBarProps) => {
  const borderRadius = `${height / 4}px`

  return (
    <Stack
      bgcolor="divider"
      borderRadius={borderRadius}
      direction="row"
      gap={2}
      height={height}
      width="100%"
    >
      {data.map((item, index) => (
        <Box
          bgcolor={item.color}
          borderRadius={borderRadius}
          height={height}
          key={index}
          width={item.percentage}
        />
      ))}
    </Stack>
  )
}

export default StatusBar
